export function priestDisplayName(row: {
  title?: string;
  firstName?: string;
  lastName?: string;
}) {
  const name = [row.title, row.firstName, row.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();
  return name || "Untitled";
}
